/* eslint-disable complexity, sonarjs/cognitive-complexity, react/jsx-boolean-value, id-match, import/no-cycle */
import { faBed, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { Element, scroller } from 'react-scroll';
import {
  CALENDAR_STEP_TWO,
  HOTEL_URL_PARAMS,
  MODALS,
} from '../../../../brands/default/constants';
import { CALENDAR_CONTAINER } from '../../../../brands/default/content/components/deal';
import {
  addOneDayToCheckinDate,
  checkIsSameDayLastAvailable,
  checkIsSameOrBefore,
  convertBookingProductToBasketProduct,
  dateCalculateNights,
  dateConvertAvailToProduct,
  dateConvertSlashToDash,
  DDMMYYSlashFormat,
  DDMMYYYYDashFormat,
  formatFlightsForBasket,
  getDefaultFlightForDate,
  getMonth,
  getProductsForDateNew,
  getYear,
  isDatesValid,
  MAX_NIGHTS_DEFAULT,
  useAvailability,
} from '../../../../helpers/booking';
import { isLightPage } from '../../../../helpers/browser';
import { formatCurrency } from '../../../../helpers/currency';
import { isBookingCalendarOnRedemptionGiftDeal } from '../../../../helpers/deals';
import ErrorTrackingService from '../../../../helpers/errorTrackingService';
import { isMobileViewport } from '../../../../helpers/screen';
import ThemeContext from '../../../../providers/ThemeProvider';
import Message, { MESSAGE_TYPES } from '../../../_generic/Message';
import BasketSocialCues from '../../../checkout/BasketSocialCues';
import DealGiftButton from '../buy-buttons/DealGiftButton';
import BookingAlternativeFlights from './BookingAlternativeFlights';
import BookingCalendar from './BookingCalendar';
import BookingCalendarAirports from './BookingCalendarAirports';
import BookingCalendarClear from './BookingCalendarClear';
import BookingCalendarNights from './BookingCalendarNights';
import BookingCalendarPackages from './BookingCalendarPackages';
import BookingCalendarPassengers from './BookingCalendarPassengers';
import BookingCalendarPayments from './BookingCalendarPayments';
import BookingCalendarPrice from './BookingCalendarPrice';
import BookingCalendarProducts from './BookingCalendarProducts';
import BookingCalendarRoomOnlyPackages from './BookingCalendarRoomOnlyPackages';
import BookingCalendarStep from './BookingCalendarStep';
import CalendarSocialCue from './CalendarSocialCue';
import ChannelManagerNights from './ChannelManagerNights';
import FlightPair from './FlightPair';
import {
  CalendarBuyButtons,
  getBuyButtonDeal,
  TravelCalendarBuyButtons,
} from './calendar';

const CalendarContainer = ({
  deal,
  isCYF,
  isGift,
  isModal = false,
  isDynamicTravelDeal = false,
  isGoogleHotel = false,
  isTravel = false,
  setIsOptionSelected = () => {},
  buttonRef = undefined,
  mainDealGiftButton,
  searchParams,
  giftingClearSelection,
  setGiftingClearSelection,
}) => {
  const theme = useContext(ThemeContext);
  const isMobile = isMobileViewport();
  let initialReadyForCalendar = true;
  let initialQuantity = deal?.pricePerPerson ? 2 : 1;
  if (isCYF) {
    initialReadyForCalendar = false;
    initialQuantity = 2;
  }

  const [error, setError] = useState(false);
  const [flightError, setFlightError] = useState(false);
  // selection
  const [dateSelection, setDateSelection] = useState(null);
  const initialDates = isDynamicTravelDeal
    ? {
        checkInDate: null,
        checkOutDate: null,
      }
    : null;
  const [beginEndDates, setBeginEndDates] = useState(initialDates);
  // CYF will need quantity(passengers) departureAirport and nights to be ready
  const [isReadyForCalendar, setIsReadyForCalendar] = useState(
    initialReadyForCalendar,
  );
  const [quantity, setQuantity] = useState(() => initialQuantity);
  const [departureAirport, setDepartureAirport] = useState('');
  const [nights, setNights] = useState('');
  const [thisDealLondonAirports, setThisDealLondonAirports] = useState(null);
  const [deposit, setDeposit] = useState(() => deal?.depositAvailable);
  const [products, setProducts] = useState(null);
  const [packages, setPackages] = useState(null);
  const [roomOnly, setRoomOnly] = useState(null);
  const [selection, setSelection] = useState(null);
  const [flights, setFlights] = useState(null);
  const [defaultFlights, setDefaultFlights] = useState(null);
  const [inBoundDate, setInBoundDate] = useState(null);
  const [priceDiff, setPriceDiff] = useState(0);
  const isBookingCalendarOnRedemptionGift =
    isBookingCalendarOnRedemptionGiftDeal(deal);
  const [isDynamicTravelGift, setIsDynamicTravelGift] = useState(false);

  const [maxNights, setMaxNights] = useState(null);
  const [nextDayCellIndex, setNextDayCellIndex] = useState(null);
  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  const [currentHoverDate, setCurrentHoverDate] = useState(null);
  const [isMouseLeftCalendar, setIsMouseLeftCalendar] = useState(true);
  const [key, setKey] = useState(
    roomOnly?.length > 0 ? 'roomonly' : 'packages',
  );
  const [showTabHeader, setShowTabHeader] = useState(
    roomOnly?.length > 0 && packages?.length > 0,
  );
  const [cmAdNights, setCmAdNights] = useState(1);
  const {
    bcorGiftMessage,
    bookingStepOne,
    bookingStepThree,
    bookingStepTwo,
    chooseArrival,
    cmChooseCheckoutDates,
    cmChooseDates,
    cmGiftStepOne,
    cmStepOne,
    cmStepThree,
    cmStepTwo,
    cyfBookingStepFive,
    cyfBookingStepFour,
    cyfBookingStepOne,
    cyfBookingStepSix,
    cyfBookingStepSixA,
    cyfBookingStepThree,
    cyfBookingStepTwo,
    depositAvailable,
    flightErrorDetails,
    giveAsAGift,
    noProducts,
    noProductsForNights,
    useOriginalFlight,
  } = CALENDAR_CONTAINER;

  let STEP_A = bookingStepOne;
  let STEP_B = bookingStepTwo;
  let STEP_C = bookingStepThree;
  if (isCYF) {
    STEP_A = cyfBookingStepFour;
    STEP_B = cyfBookingStepFive;
    STEP_C = cyfBookingStepSix;
  }
  if (isDynamicTravelDeal) {
    STEP_A = isDynamicTravelGift ? cmGiftStepOne : cmStepOne;
    STEP_B = cmStepTwo;
    STEP_C = cmStepThree;
  }

  const setRoomOnlyTab = (tabKey) => {
    setKey(tabKey);
    if (tabKey === 'packages' && packages?.length > 0) {
      // select the first package
      const newPackage = packages[0].calendarProductView[0];
      setSelection(newPackage);
      setIsOptionSelected(true);
    } else if (tabKey === 'roomonly' && roomOnly?.length > 0) {
      const urlProductId = searchParams.get(HOTEL_URL_PARAMS.product_id);
      let newRoomOnlySelection;
      if (urlProductId) {
        // if the product id in url is in the list select that one
        newRoomOnlySelection = roomOnly.find(
          (product) =>
            product.dealVoucherProductId === Number.parseInt(urlProductId, 10),
        );
      }
      if (!newRoomOnlySelection) {
        // select the first package as default
        newRoomOnlySelection = roomOnly[0];
      }

      setSelection(newRoomOnlySelection);
      setIsOptionSelected(true);
    } else {
      setSelection(null);
      setIsOptionSelected(false);
    }
  };

  const onChooseOriginalFlight = () => {
    setFlights(defaultFlights);
    setPriceDiff(Number.parseFloat(defaultFlights.priceDiff));
  };

  const onChooseFlight = (flightPair) => {
    // choosing an alternative flight
    const formattedFlights = formatFlightsForBasket(flightPair);
    setFlights(formattedFlights);
    // priceDiff will modify the price, show at the bottom and in product
    setPriceDiff(Number.parseFloat(formattedFlights.priceDiff));
  };

  const getIncludedFlight = async () => {
    const newFlights = await getDefaultFlightForDate(
      dateSelection,
      selection.dealVoucherProductId,
    );
    if (newFlights?.departureAirport && newFlights?.arrivalAirport) {
      const formattedFlights = formatFlightsForBasket(newFlights);
      setFlights(formattedFlights);
      setDefaultFlights(formattedFlights);
      setInBoundDate(formattedFlights.inbound.departureTime);
      setPriceDiff(Number.parseFloat(formattedFlights.priceDiff));
      setFlightError(false);
    } else {
      setFlightError(true);
    }
  };

  const getProducts = async (
    date,
    checkIn,
    checkOut,
    isDynamicGift,
    newNights,
    // eslint-disable-next-line max-params
  ) => {
    const { newMaxNights, newPackages, newProducts, newRoomOnly } =
      await getProductsForDateNew(
        deal,
        date,
        quantity,
        departureAirport,
        newNights ? newNights : nights,
        isReadyForCalendar,
        thisDealLondonAirports,
        isDynamicTravelDeal,
        isDynamicGift,
        dateConvertSlashToDash(checkIn) ||
          dateConvertSlashToDash(beginEndDates?.checkInDate),
        dateConvertSlashToDash(checkOut) ||
          dateConvertSlashToDash(beginEndDates?.checkOutDate),
        isGoogleHotel,
        searchParams,
      );
    if (newProducts) {
      // existing flow
      setProducts(newProducts);
      // select first available product as default
      const firstProduct = newProducts.find(
        (product) => product.productAvailable,
      );
      setSelection(firstProduct);
      setIsOptionSelected(true);
    }

    // Ideally add some loaders for gifting UI
    if (
      !isDynamicGift ||
      (isDynamicGift && newMaxNights?.includes(Number.parseInt(newNights, 10)))
    ) {
      setPackages(newPackages);
    }

    if (newPackages) {
      // dynamic travel deal flow

      // select first available product as default
      // select the first package
      const firstPackage = newPackages[0]?.calendarProductView;
      if (firstPackage && firstPackage.length > 0) {
        const firstProduct = firstPackage.find(
          (product) => product.productAvailable,
        );
        setSelection(firstProduct);
      }

      if (
        newMaxNights &&
        Array.isArray(newMaxNights) &&
        newMaxNights.length > 0
      ) {
        setMaxNights(newMaxNights);
      } else {
        setMaxNights(MAX_NIGHTS_DEFAULT);
      }
    }

    setRoomOnly(newRoomOnly);
    if (newRoomOnly && newRoomOnly?.length > 0) {
      // room pnly for referral from google hotel ads

      const urlProductId = searchParams.get(HOTEL_URL_PARAMS.product_id);
      let newRoomOnlySelection;
      if (urlProductId) {
        // if the product id in url is in the list select that one
        newRoomOnlySelection = newRoomOnly.find(
          (product) =>
            product.dealVoucherProductId === Number.parseInt(urlProductId, 10),
        );
      }
      if (!newRoomOnlySelection) {
        // select first available product as default
        newRoomOnlySelection = newRoomOnly.find(
          (product) => product.productAvailable,
        );
      }

      setSelection(newRoomOnlySelection);
      setIsOptionSelected(true);
    }

    if (!isModal) {
      scroller.scrollTo(CALENDAR_STEP_TWO, {
        delay: 100,
        duration: 1_000,
        smooth: true,
      });
    } else if (isModal) {
      try {
        scroller.scrollTo(CALENDAR_STEP_TWO, {
          containerId: MODALS.dealAvailability,
          delay: 100,
          duration: 500,
          smooth: true,
        });
      } catch (error_) {
        console.warn(error_);
        ErrorTrackingService.logError(error_);
      }
    }
  };

  const selectProduct = (product) => {
    if (product) {
      setSelection(product);
      setIsOptionSelected(true);
    }
  };

  const buyButtonDeal = getBuyButtonDeal({
    convertBookingProductToBasketProduct,
    deal,
    deposit,
    flights,
    quantity,
    selection,
  });

  const setCurrentLondonAirports = (londonAirports) => {
    if (isCYF) setThisDealLondonAirports(londonAirports);
  };

  const selectAirport = (newAirportCode) => {
    if (isCYF) {
      setDateSelection(null);
      setSelection(null);
      setIsOptionSelected(false);
      setFlights(null);
      setDefaultFlights(null);
      setDepartureAirport(newAirportCode);
    }
  };

  const selectNights = (newNights) => {
    if (isCYF) {
      setDateSelection(null);
      setSelection(null);
      setIsOptionSelected(false);
      setFlights(null);
      setDefaultFlights(null);
      setNights(newNights);
    }
    if (isDynamicTravelGift) {
      getProducts('', '', '', true, newNights.toString());
      setNights(newNights.toString());
    }
  };

  const selectQuantity = (newQuantity) => {
    if (isCYF) {
      setDateSelection(null);
      setSelection(null);
      setIsOptionSelected(false);
      setFlights(null);
      setDefaultFlights(null);
    }
    setQuantity(Number.parseInt(newQuantity, 10));
  };

  const selectEndDate = (date) => {
    // isDynamicTravelDeal only for nights - +
    if (isDynamicTravelDeal && dateSelection) {
      // first date had been selected, second click will choose end date
      // setCurrentLastSelectableDate(null);
      const newDates = {
        ...beginEndDates,
        checkOutDate: dateConvertAvailToProduct(date),
      };
      setBeginEndDates(newDates);
      getProducts(
        date,
        beginEndDates.checkInDate,
        dateConvertAvailToProduct(date),
      );
      setSelection(null);
      setIsOptionSelected(false);
    }

    setError(false);
  };

  const handleLastAvailableDate = (currentLastAvailableStay, date) => {
    // if this date matches lastAvailableStay auto select the next day as checkout
    if (checkIsSameDayLastAvailable(currentLastAvailableStay, date)) {
      const newCheckoutDate = addOneDayToCheckinDate(date);
      const newDates = {
        ...beginEndDates,
        checkInDate: dateConvertAvailToProduct(date),
        checkOutDate: dateConvertAvailToProduct(newCheckoutDate),
      };
      setBeginEndDates(newDates);
      // both dates are selected, get products
      getProducts(
        date,
        dateConvertAvailToProduct(date),
        dateConvertAvailToProduct(newCheckoutDate),
      );
    }
  };

  // call to get cells
  const {
    cells,
    next,
    prev,
    displayMonth,
    displayYear,
    errorCells,
    lastAvailableStay,
    isCheckinNearMonthEnd,
  } = useAvailability(
    deal,
    month,
    year,
    selection,
    quantity,
    departureAirport,
    nights,
    isReadyForCalendar,
    thisDealLondonAirports,
    false,
    beginEndDates,
    currentHoverDate,
    isMouseLeftCalendar,
  );

  const handleSetNextDay = (cellIndex) => {
    if (cells && cells[cellIndex + 1]) {
      // set next days cellIndex for auto select
      setNextDayCellIndex(cellIndex + 1);
    } else {
      setNextDayCellIndex(null);
    }
  };

  const selectDate = ({ date, cellIndex }) => {
    if (isDynamicTravelDeal) {
      if (dateSelection) {
        if (beginEndDates.checkInDate && beginEndDates.checkOutDate) {
          // both dates have been selected, click will choose first date again
          // reset lastSelectableDate
          // setCurrentLastSelectableDate(null);
          const newDates = {
            ...initialDates,
            checkInDate: dateConvertAvailToProduct(date),
          };
          setBeginEndDates(newDates);
          // reset the products as only checkin is selected now
          setPackages(null);
          // if this date matches lastAvailableStay auto select the next day as checkout
          handleLastAvailableDate(lastAvailableStay, date);
          handleSetNextDay(cellIndex);
        } else if (
          checkIsSameOrBefore(
            date,
            DDMMYYYYDashFormat,
            beginEndDates.checkInDate,
            DDMMYYSlashFormat,
          )
        ) {
          // one date selected, make the new selection first date
          const newDates = {
            ...beginEndDates,
            checkInDate: dateConvertAvailToProduct(date),
          };
          setBeginEndDates(newDates);
          handleSetNextDay(cellIndex);
        } else {
          // first date had been selected, second click will choose end date
          const newDates = {
            ...beginEndDates,
            checkOutDate: dateConvertAvailToProduct(date),
          };
          setBeginEndDates(newDates);
          // both dates selected, get products
          getProducts(
            date,
            beginEndDates.checkInDate,
            dateConvertAvailToProduct(date),
          );
        }

        // getProducts(date);
        setSelection(null);
        setIsOptionSelected(false);
      } else {
        setDateSelection(date);
        const newDates = {
          ...beginEndDates,
          checkInDate: dateConvertAvailToProduct(date),
        };
        setBeginEndDates(newDates);

        // if this date matches lastAvailableStay auto select the next day as checkout
        handleLastAvailableDate(lastAvailableStay, date);
        handleSetNextDay(cellIndex);
        // getProducts(date);
        setSelection(null);
        setIsOptionSelected(false);
      }
    } else {
      setDateSelection(date);
      getProducts(date);
      setSelection(null);
      setIsOptionSelected(false);
      if (isCYF) {
        setFlights(null);
        setDefaultFlights(null);
        setFlightError(false);
      }
    }

    setError(false);
  };

  const onSelectProduct = (product) => {
    if (product?.dealVoucherProductId !== selection?.dealVoucherProductId) {
      selectProduct(product);
    }
  };

  const onReset = () => {
    setBeginEndDates(initialDates);
    setDateSelection(null);
    setSelection(null);
    setIsOptionSelected(false);
    setRoomOnly(null);
    setPackages(null);
    // setCurrentLastSelectableDate(null);
    if (isCYF) {
      setFlights(null);
      setDefaultFlights(null);
      setFlightError(false);
    }
    if (!isCYF) {
      setQuantity(initialQuantity);
      setFlightError(false);
    }
    setError(false);
  };

  const isButtonClickValid = () => {
    // possible auto selecting of checkout date
    if (
      isDynamicTravelDeal &&
      !isDynamicTravelGift &&
      beginEndDates.checkInDate &&
      !beginEndDates.checkOutDate &&
      nextDayCellIndex &&
      cells &&
      cells[nextDayCellIndex] &&
      cells[nextDayCellIndex].isSelectable
    ) {
      const endDate = cells[nextDayCellIndex].key;
      // set new checkout date
      const newDates = {
        ...beginEndDates,
        checkOutDate: dateConvertAvailToProduct(endDate),
      };
      setBeginEndDates(newDates);
      // get products
      getProducts(
        endDate,
        beginEndDates.checkInDate,
        dateConvertAvailToProduct(endDate),
      );
      setSelection(null);
      setIsOptionSelected(false);

      return false;
    }

    if (
      (dateSelection === null && !isDynamicTravelGift) ||
      !buyButtonDeal ||
      (isCYF && flights === null) ||
      (isDynamicTravelDeal && packages?.length === 0)
    ) {
      setError(true);

      return false;
    }

    return true;
  };

  useEffect(() => {
    if (selection && isCYF) {
      getIncludedFlight();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selection]);

  useEffect(() => {
    if (isCYF && departureAirport !== '' && nights !== '') {
      setIsReadyForCalendar(true);
    }
  }, [isCYF, departureAirport, nights, thisDealLondonAirports]);

  useEffect(() => {
    if (isDynamicTravelDeal && isGift) {
      setIsDynamicTravelGift(true);
      getProducts('', '', '', true, '1');
    } else {
      setIsDynamicTravelGift(false);
    }
  }, [isDynamicTravelDeal, isGift]);

  useEffect(() => {
    setKey(roomOnly?.length > 0 ? 'roomonly' : 'packages');
    setShowTabHeader(roomOnly?.length > 0 && packages?.length > 0);
  }, [roomOnly, packages]);

  useEffect(() => {
    if (isGoogleHotel && searchParams) {
      // if we have dates set them
      const newCheckInDash = searchParams.get(HOTEL_URL_PARAMS.arrival);
      const newCheckOutDash = searchParams.get(HOTEL_URL_PARAMS.departure);
      // need to set month and year on the calendar from dates in url
      if (newCheckInDash) {
        setMonth(getMonth(newCheckInDash, DDMMYYYYDashFormat) + 1);
        setYear(getYear(newCheckInDash, DDMMYYYYDashFormat));
      }

      // date validity
      const isCheckInCheckOutValid = isDatesValid(
        newCheckInDash,
        DDMMYYYYDashFormat,
        newCheckOutDash,
        DDMMYYYYDashFormat,
      );
      if (newCheckInDash && newCheckOutDash && isCheckInCheckOutValid) {
        const newCheckIn = dateConvertAvailToProduct(newCheckInDash);
        const newCheckOut = dateConvertAvailToProduct(newCheckOutDash);
        const newDates = {
          ...beginEndDates,
          checkInDate: newCheckIn,
          checkOutDate: newCheckOut,
        };
        setBeginEndDates(newDates);
        setDateSelection(newCheckOutDash);
        // cm nights from url params
        const newCmNights = dateCalculateNights(newCheckIn, newCheckOut) || 1;
        setCmAdNights(Number.parseInt(newCmNights, 10));
        if (!isGift) {
          // get products
          getProducts(newCheckOutDash, newCheckIn, newCheckOut);
        }
      }
    }
  }, [isGoogleHotel, searchParams]);

  useEffect(() => {
    if (giftingClearSelection) onReset();
  }, [giftingClearSelection]);

  const onNext = () => {
    if (next) {
      setMonth(next.month);
      setYear(next.year);
    }
  };

  const onPrevious = () => {
    if (prev) {
      setMonth(prev.month);
      setYear(prev.year);
    }
  };

  const onHoverDate = (date) => {
    setCurrentHoverDate(date);
    setIsMouseLeftCalendar(false);
  };

  const onHoverOffCells = () => {
    setIsMouseLeftCalendar(true);
  };

  if (isLightPage()) {
    return null;
  }

  return (
    <>
      {deal?.depositAvailable && (
        <Message
          message={depositAvailable(
            formatCurrency(deal?.currency, deal?.depositPrice, false, false),
          )}
          showIcon={false}
          type={MESSAGE_TYPES.success}
        />
      )}

      {isCYF && (
        <>
          <BookingCalendarStep title={cyfBookingStepOne} />
          <BookingCalendarPassengers
            initialQuantity={initialQuantity}
            onQuantityChange={selectQuantity}
          />
          <BookingCalendarStep title={cyfBookingStepTwo} />
          <BookingCalendarAirports
            deal={deal}
            onAirportChange={selectAirport}
            setCurrentLondonAirports={setCurrentLondonAirports}
          />
          <BookingCalendarStep title={cyfBookingStepThree} />
          <BookingCalendarNights deal={deal} onNightChange={selectNights} />
        </>
      )}

      {isDynamicTravelGift && (
        <>
          <BookingCalendarStep stepIndex="1" title={STEP_A} />
          {maxNights && (
            <ChannelManagerNights
              initialNights={cmAdNights}
              maxNights={maxNights}
              onNightChange={selectNights}
            />
          )}
        </>
      )}

      {isReadyForCalendar && !isDynamicTravelGift && (
        <>
          <BookingCalendarStep
            stepIndex={isDynamicTravelDeal ? '1' : null}
            title={STEP_A}
          >
            {!isDynamicTravelDeal && <BookingCalendarClear onClick={onReset} />}
          </BookingCalendarStep>
          <BookingCalendar
            beginEndDates={beginEndDates}
            cells={cells}
            deal={deal}
            departureAirport={departureAirport}
            displayMonth={displayMonth}
            displayYear={displayYear}
            errorCYF={errorCells && isCYF}
            handleOnHoverDate={onHoverDate}
            handleOnHoverOffCells={onHoverOffCells}
            handleOnNext={onNext}
            handleOnPrevious={onPrevious}
            isCheckinNearMonthEnd={isCheckinNearMonthEnd}
            isReadyForCalendar={isReadyForCalendar}
            next={next}
            nights={nights}
            onSelect={selectDate}
            onSelectEndDate={selectEndDate}
            prev={prev}
            quantity={quantity}
            resetCalendar={onReset}
            selection={selection}
            thisDealLondonAirports={thisDealLondonAirports}
          />
        </>
      )}

      {!isDynamicTravelDeal && dateSelection && products && selection && (
        <>
          <Element name={CALENDAR_STEP_TWO} />
          <BookingCalendarStep title={STEP_B} />
          <BookingCalendarProducts
            currency={deal?.currency}
            isCYF={isCYF}
            onQuantityChange={selectQuantity}
            onSelect={onSelectProduct}
            priceDiff={priceDiff}
            products={products}
            quantity={quantity}
            selection={selection}
          />
        </>
      )}

      {((isDynamicTravelDeal && dateSelection && !isGoogleHotel) ||
        isDynamicTravelGift) &&
        packages?.length > 0 && (
          <>
            <Element name={CALENDAR_STEP_TWO} />
            <BookingCalendarStep stepIndex="2" title={STEP_B} />
            <BookingCalendarPackages
              currency={deal?.currency}
              isDynamicTravelGift={isDynamicTravelGift}
              onQuantityChange={selectQuantity}
              onSelect={onSelectProduct}
              packages={packages}
              quantity={quantity}
              selection={selection}
            />
          </>
        )}

      {isGoogleHotel && dateSelection && !isDynamicTravelGift && (
        <>
          <Element name={CALENDAR_STEP_TWO} />
          <BookingCalendarStep stepIndex="2" title={STEP_B} />
          <Tab.Container
            activeKey={key}
            defaultActiveKey="roomonly"
            id="roomonly-packages"
            onSelect={(eventKey) => setRoomOnlyTab(eventKey)}
          >
            {showTabHeader && (
              <Nav className="roomonly-tabs" variant="tabs">
                <Nav.Item className="roomonly-tab">
                  <Nav.Link eventKey="roomonly">
                    <FontAwesomeIcon icon={faBed} />
                    &nbsp; Room
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="roomonly-tab-or">
                  <b>or</b>
                </Nav.Item>
                <Nav.Item className="roomonly-tab">
                  <Nav.Link eventKey="packages">
                    <FontAwesomeIcon icon={faUtensils} />
                    &nbsp; Room + Package
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            )}
            <Tab.Content>
              <Tab.Pane eventKey="roomonly">
                <>
                  {roomOnly?.length > 0 && (
                    <BookingCalendarRoomOnlyPackages
                      currency={deal?.currency}
                      isDynamicTravelGift={isDynamicTravelGift}
                      onQuantityChange={selectQuantity}
                      onSelect={onSelectProduct}
                      packages={roomOnly}
                      quantity={quantity}
                      selection={selection}
                    />
                  )}
                </>
              </Tab.Pane>
              <Tab.Pane eventKey="packages">
                <>
                  {packages?.length > 0 && (
                    <BookingCalendarPackages
                      currency={deal?.currency}
                      isDynamicTravelGift={isDynamicTravelGift}
                      onQuantityChange={selectQuantity}
                      onSelect={onSelectProduct}
                      packages={packages}
                      quantity={quantity}
                      resetPackage={key}
                      selection={selection}
                    />
                  )}
                </>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </>
      )}

      {!isCYF &&
        !isDynamicTravelDeal &&
        deal?.depositAvailable &&
        dateSelection &&
        selection && (
          <>
            <BookingCalendarStep title={STEP_C} />
            <BookingCalendarPayments
              currency={deal?.currency}
              depositPrice={selection.depositPrice}
              fullPrice={selection.price}
              onSelect={(value) => setDeposit(value)}
              selection={deposit}
            />
          </>
        )}
      {isCYF && flights && dateSelection && selection && (
        <>
          <BookingCalendarStep
            title={
              isEqual(flights, defaultFlights) ? STEP_C : cyfBookingStepSixA
            }
          >
            {!isEqual(flights, defaultFlights) && (
              <b>
                (
                <a
                  className="original-flight"
                  onClick={onChooseOriginalFlight}
                  onKeyDown={onChooseOriginalFlight}
                  role="button"
                  tabIndex={0}
                >
                  {useOriginalFlight}
                </a>
                )
              </b>
            )}
          </BookingCalendarStep>
          <FlightPair flights={flights} />
          <BookingAlternativeFlights
            chooseFlight={onChooseFlight}
            date={dateSelection}
            departureAirport={departureAirport}
            inBoundDate={inBoundDate}
            priceDiff={priceDiff}
            productId={selection.dealVoucherProductId}
            selectedFlightPair={flights}
            thisDealLondonAirports={thisDealLondonAirports}
          />
          <BookingCalendarPrice
            price={Number.parseFloat(selection.price) + priceDiff}
          />
        </>
      )}
      {packages?.length === 0 && (
        <Message
          extraClasses="message-no-background message-center message-border-radius"
          message={isDynamicTravelGift ? noProductsForNights : noProducts}
          showIcon={false}
          type={MESSAGE_TYPES.error}
        />
      )}
      {error && !flightError && !isGift && (
        <>
          {!isDynamicTravelDeal && (
            <Message
              extraClasses="message-no-background message-center message-border-radius"
              message={chooseArrival}
              showIcon={false}
              type={MESSAGE_TYPES.error}
            />
          )}
          {isDynamicTravelDeal && (
            <Message
              extraClasses="message-no-background message-center message-border-radius"
              message={dateSelection ? cmChooseCheckoutDates : cmChooseDates}
              showIcon={false}
              type={MESSAGE_TYPES.error}
            />
          )}
        </>
      )}
      {flightError && (
        <Message
          extraClasses="message-no-background message-center message-border-radius"
          message={flightErrorDetails}
          showIcon={false}
          type={MESSAGE_TYPES.error}
        />
      )}

      <CalendarSocialCue deal={deal} />
      {isDynamicTravelGift && (
        <>
          <Message iconPosition="left" message={bcorGiftMessage} showIcon />
        </>
      )}
      {/* modal-sticky */}
      <div className="modal-sticky">
        {isTravel
          ? TravelCalendarBuyButtons({
              buttonRef,
              buyButtonDeal,
              deal,
              deposit,
              isBookingCalendarOnRedemptionGift,
              isButtonClickValid,
              isGiftable: deal?.giftable,
              isGoogleHotel,
              searchParams,
              setGiftingClearSelection,
            })
          : CalendarBuyButtons({ buyButtonDeal, isButtonClickValid, isGift })}

        {isMobile &&
          deal?.giftable &&
          deal?.category?.canonicalPathType === 'travel' &&
          (isBookingCalendarOnRedemptionGift || isDynamicTravelDeal ? (
            mainDealGiftButton
          ) : (
            <>
              <DealGiftButton
                /* eslint-disable-next-line react/forbid-component-props */
                className="primary-button full-width outline gifting"
                deal={buyButtonDeal}
                isValidExternal={isButtonClickValid}
                text={giveAsAGift}
              />
            </>
          ))}
      </div>
      {isDynamicTravelGift && <BasketSocialCues />}

      <style jsx>{`
        .original-flight {
          color: ${theme.colors.primary};
        }
        :global(.roomonly-tabs) {
          margin-bottom: 20px;
        }
        :global(.roomonly-tab) {
          flex: 1 1 auto;
        }
        :global(.roomonly-tab-or) {
          line-height: 30px;
          margin: 0 10px;
        }
        :global(.nav-tabs .nav-link) {
          border-bottom: 2px solid #aeaeae;
          margin: 0;
          text-align: center;
        }
        :global(.nav-tabs .nav-link.active) {
          border-bottom: 2px solid ${theme.colors.primary};
          color: ${theme.colors.primary};
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .modal-sticky {
            position: sticky;
            bottom: 0;
            z-index: 10;
          }
        }
      `}</style>
    </>
  );
};

CalendarContainer.propTypes = {
  buttonRef: PropTypes.any,
  deal: PropTypes.object.isRequired,
  isCYF: PropTypes.bool.isRequired,
  isDynamicTravelDeal: PropTypes.bool,
  isGift: PropTypes.bool,
  isGoogleHotel: PropTypes.bool,
  isModal: PropTypes.bool,
  isTravel: PropTypes.bool,
  mainDealGiftButton: PropTypes.elementType,
  searchParams: PropTypes.object,
  setIsOptionSelected: PropTypes.func,
};

export default CalendarContainer;
